import { render } from "./TermsOfService.vue?vue&type=template&id=63d45180"
import script from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/TermsOfService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63d45180"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63d45180', __exports__)) {
    api.reload('63d45180', __exports__)
  }
  
  module.hot.accept("./TermsOfService.vue?vue&type=template&id=63d45180", () => {
    api.rerender('63d45180', render)
  })

}


export default __exports__